import Organization from "./Organization";
import SbomProject from "./SbomProject";

class SbomProjectGroup {

    constructor(
        public id?: string,
        public name?: string,
        public description?: string,
        public organization?: Organization,
        public projectIds?: string[],
        public projects?: SbomProject[]) {
        //
    }

    public static fromPOJO(data: any) {
        if (!data) {
            return null;
        }

        const group = new SbomProjectGroup();
        const projects = (data.projects ?? [])
            .map(projectData => SbomProject.fromPOJO(projectData))
            .filter((project): project is SbomProject => project !== null);

        group.id = data.id;
        group.name = data.name;
        group.description = data.description;
        group.organization = (data.organization) ? Organization.fromPOJO(data.organization) : undefined;
        group.projects = projects;
        group.projectIds = projects
            .map(project => project.id)
            .filter((id): id is string => id !== undefined);

        return group;
    }

}

export default SbomProjectGroup;
